import React, { useState } from 'react'

import './counter-field.css'

const CounterField = (props) => {
  const { value: initValue = 0, onChange, min = 1, max, item } = props
  const [value, setValue] = useState(initValue || min)

  const getNewValue = (value = 0) => {
    if (Number(value) < min ) {
      return min
    }
    if (Number(value) > max) {
      return max
    }
    return Number(value)
  }

  const onFieldChange = (e) => {
    const { value: inputValue } = e.target
    setValue(getNewValue(inputValue))
    onChange({
      ...item,
      count: getNewValue(inputValue)
    })
  }

  return (
    <div className='counter-field'>
      <div
        className='counter-field__button counter-field__button-decrement'
        onClick={() => {
          setValue((previousValue) => {
            onChange({
              ...item,
              count: getNewValue(Number(previousValue) - 1),
            })
            return getNewValue(Number(previousValue) - 1)
          })
        }}
      >
        -
      </div>
      <input
        onChange={onFieldChange}
        type='text'
        value={value}
        max={max}
        min={min}
      />
      <div
        className='counter-field__button counter-field__button-increment'
        onClick={() => {
          setValue((previousValue) => {
            onChange({
              ...item,
              count: getNewValue(Number(previousValue) + 1),
            })
            return getNewValue(Number(previousValue) + 1)
          })
        }}
      >
        +
      </div>
    </div>
  )
}

export default CounterField
